export default {
  Quicksand: {
    googleFontQuery: 'Quicksand:100,300,400,500,600,700&subset=cyrillic,cyrillic-ext',
    fontFamily: '\'Quicksand\', sans-serif',
  },
  Comfortaa: {
    googleFontQuery: 'Comfortaa:100,300,400,500,600,700',
    fontFamily: '\'Comfortaa\', sans-serif',
  },
};
